import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Modal } from "antd";
import { isIOS, isChrome, isSafari } from "react-device-detect";
import { useTranslation } from "react-i18next";
import "./App.css";
import AppHeader from "./components/header/header";
import ProcessDetail from "./containers/process-detail";
import Interview from "./containers/interview";
import RecorderTest from "./containers/video-test";
import Finished from "./containers/Finished";
import Expired from "./containers/Expired";
import NotFound from "./containers/NotFound";
import { ProcessProvider } from "./contexts/ProcessContext";

function App() {
  const { t } = useTranslation();

  useEffect(() => {
    if (isIOS && !isSafari) {
      Modal.error({
        centered: true,
        title: t("frontvint__unsupported_browser_title"),
        content: t("frontvint__unsupported_browser_ios_content"),
      });
    } else if (!isIOS && !isChrome) {
      Modal.error({
        centered: true,
        title: t("frontvint__unsupported_browser_not_chrome_title"),
        content: t("frontvint__unsupported_browser_not_chrome_content"),
      });
    }
  });

  return (
    <div className="App">
      <AppHeader />
      <Router>
        <Switch>
          <Route path="/processes/:id">
            <ProcessProvider>
              <Switch>
                <Route path="/processes/:id/test" component={RecorderTest} />
                <Route path="/processes/:id/expired" component={Expired} />
                <Route path="/processes/:id/finished" component={Finished} />
                <Route path="/processes/:id/not-found" component={NotFound} />
                <Route path="/processes/:id/interview" component={Interview} />
                <Route exact path="/processes/:id" component={ProcessDetail} />
              </Switch>
            </ProcessProvider>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
